import fromAnyToString from 'utils/converters/fromAnyToString';
import asObject from 'utils/objects/asObject.util';

const fromIdToElement = (id) => (document && document.getElementById(id)) || void 1;
const fromSelectorToElement = (selector) => (document && document.querySelector(selector)) || void 1;

const findFrame = (options) => {
  const {
    target,
    element: elementFromOptions,
    elementId: idFromOptions,
    elementSelector: selectorFromOptions,
  } = asObject(options);

  const id = fromAnyToString(idFromOptions);
  const selector = fromAnyToString(selectorFromOptions);

  const element =
    // eslint-disable-next-line no-nested-ternary
    elementFromOptions || (id ? fromIdToElement(id) : selector ? fromSelectorToElement(selector) : void 1);

  const elementId = id || asObject(element).id || void 1;
  const elementSelector = selector || (elementId ? `#${elementId}` : void 1);

  const contentWindow = target || (element ? element.contentWindow : void 1);
  const src = element ? element.src : void 1;

  return { element, contentWindow, src, elementId, elementSelector };
};

// noinspection JSUnusedGlobalSymbols
export default findFrame;
